import CityPageTemplate from "../city-template/CityPageTemplate";
import { wahpetonConfig } from "./data";

export default function WahpetonPage() {
  return <CityPageTemplate config={wahpetonConfig} />;
}